export function enableNextButton(enable = true) {
  const next = document.querySelector(".btn--next");
  if (next) {
    enable
      ? next.removeAttribute("disabled")
      : next.setAttribute("disabled", "");

    enable
      ? next.classList.remove("isdisabled")
      : next.classList.add("isdisabled");
  }
}

export function focusAndClearInputs(html, surveyMTC) {
  // add focus/blur events to the <input text>
  const inputText = html.querySelector(
    'input[type="text"],input[type="email"],textarea'
  );
  if (inputText) {
    if (inputText.value !== "") {
      inputText.classList.add("filled-in");
    }

    inputText.addEventListener("blur", function () {
      this.classList.remove("focused");
      if (this.value !== "") {
        this.classList.add("filled-in");
      } else {
        this.classList.remove("filled-in");
      }
    });

    inputText.addEventListener("focus", function () {
      this.classList.add("focused");
      this.classList.remove("filled-in");
    });

    if (inputText.nodeName === "TEXTAREA") {
      inputText.addEventListener("keypress", function (e) {
        if (e.which === 13) {
          e.preventDefault();
          return false;
        }
      });
    }
  }

  // add clear button to text field
  const input = html.querySelector(
    "input.sv_q_text_root:not(#products-search-box), textarea"
  );
  if (input) {
    const btn = document.createElement("button");
    btn.innerHTML = "×";
    btn.className = "sv_clear";
    btn.setAttribute("tabIndex", "-1");
    // wrap with <span>
    const div = input.parentNode;
    const span = document.createElement("span");
    span.className = "form-group";
    div.parentNode.insertBefore(span, div);
    span.appendChild(div);

    input.parentNode.classList.add("input-wrapper");

    const labelText = input.getAttribute("placeholder");
    if (labelText) {
      // create a label for "other" textarea
      input.setAttribute("placeholder", "");
      const label = document.createElement("label");
      label.innerHTML = `<span>${labelText}:</span>`;
      label.className = "sv_q_instructions";
      input.parentNode.insertBefore(label, input);
      label.appendChild(input);
    }

    input.insertAdjacentElement("afterend", btn);
    btn.addEventListener("click", function () {
      input.value = "";
      input.classList.remove("filled-in");
      // "other" checkbox
      if (input.classList.contains("sv_q_checkbox_other")) {
        //uncheckOther(surveyMTC);
      } else {
        // clear answer value
        const name = document.querySelector(".sv_qstn")?.getAttribute("name");
        surveyMTC.setValue(name, null);
        enableNextButton(false);
      }
    });
  }
}

// uncheck the "Other" checkbox - on blur with empty value or clearing the texarea using the button
export function uncheckOther(surveyMTC) {
  const name = document.querySelector(".sv_qstn")?.getAttribute("name");
  surveyMTC.setComment(name, "");
  surveyMTC.setValue(
    name,
    surveyMTC.getValue(name).filter((item) => item !== "other")
  );
}
